import { PROFILE_DATA_FIELDS } from 'models/ProfileInfo/constants'

export const PROFILE_REWARDS_CATEGORIES = {
  TRAIT: 'trait',
  INTEREST: 'interest',
  READING: 'reading',
  WATCHING: 'watching',
  HOUSEHOLD_INFORMATION: 'household_information',
  FINANCIAL_INFORMATION: 'financial_information',
  PURCHASE_HISTORY: 'purchase_history',
  DONATION_HISTORY: 'donation_history',
  CREDIT_CARD_INFORMATION: 'credit_card_information',
  INVESTMENT_HISTORY: 'investment_history',
  OTHER: 'other',
}

export const PROFILE_REWARDS_CATEGORIES_ORDER = [
  PROFILE_REWARDS_CATEGORIES.TRAIT,
  PROFILE_REWARDS_CATEGORIES.INTEREST,
  PROFILE_REWARDS_CATEGORIES.READING,
  PROFILE_REWARDS_CATEGORIES.WATCHING,
  PROFILE_REWARDS_CATEGORIES.HOUSEHOLD_INFORMATION,
  PROFILE_REWARDS_CATEGORIES.FINANCIAL_INFORMATION,
  PROFILE_REWARDS_CATEGORIES.PURCHASE_HISTORY,
  PROFILE_REWARDS_CATEGORIES.DONATION_HISTORY,
  PROFILE_REWARDS_CATEGORIES.CREDIT_CARD_INFORMATION,
  PROFILE_REWARDS_CATEGORIES.INVESTMENT_HISTORY,
  PROFILE_REWARDS_CATEGORIES.OTHER,
]

export const PROFILE_REWARDS_QUESTION_TYPES = {
  TEXT: 'text',
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
}

export const PROFILE_REWARDS_CUSTOM_QUESTION_TYPES = {
  TEXT_POSTAL_CODE: 'text_postal_code',
  SINGLE_SELECT_GENDER: 'single_select_gender',
  DATE_DATE_OF_BIRTH: 'date_date_of_birth',
}

export const PROFILE_REWARDS_CUSTOM_QUESTION_TYPES_TO_PROFILE_DATA_FIELD = {
  [PROFILE_REWARDS_CUSTOM_QUESTION_TYPES.TEXT_POSTAL_CODE]: PROFILE_DATA_FIELDS.POSTAL_CODE,
  [PROFILE_REWARDS_CUSTOM_QUESTION_TYPES.SINGLE_SELECT_GENDER]: PROFILE_DATA_FIELDS.GENDER,
  [PROFILE_REWARDS_CUSTOM_QUESTION_TYPES.DATE_DATE_OF_BIRTH]: PROFILE_DATA_FIELDS.DATE_OF_BIRTH,
}

export const PROFILE_REWARDS_ANSWER_SOURCES = {
  KID: 'kid',
  USER: 'user',
  ALL: 'all',
  ONE_EIGHTY_BY_TWO: '180-by-two',
  DIGI_CENTER: 'digi-center',
}
